import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export const STATUSES = { APERTA: "Aperta", IN_LAVORAZIONE: "In lavorazione", COMPLETATA: "Completata", RIFIUTATA: "Rifiutata" };

export const StatusDialog = ({ item, onClose, onSaved }) => {
  const [status, setStatus] = useState("APERTA");
  const [reply, setReply] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (item) { setStatus(item.status); setReply(item.admin_reply || ""); } }, [item]);
  if (!item) return null;
  const auto = item.type === "TELEPASS" && item.subtype !== "NUOVO" && status === "COMPLETATA" && item.status !== "COMPLETATA";

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/requests/${item.id}/status`, { status, admin_reply: reply });
      toast.success(data.applied ? `Stato aggiornato · ${data.applied}` : "Stato aggiornato");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="request-status-dialog">
        <DialogHeader>
          <DialogTitle>Gestisci richiesta</DialogTitle>
          <DialogDescription>{item.station_name} · {item.description || item.subtype}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label>Stato</Label>
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger data-testid="request-status-select"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(STATUSES).map(([k, l]) => <SelectItem key={k} value={k} data-testid={`request-status-${k}`}>{l}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {auto && <p className="rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-xs text-sky-800" data-testid="request-auto-note">Alla conferma il Telepass {item.telepass_number} verrà aggiornato in automatico.</p>}
          <div className="space-y-1.5"><Label>Risposta per la stazione</Label><Textarea rows={3} value={reply} onChange={(e) => setReply(e.target.value)} data-testid="request-reply-input" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={saving} data-testid="request-status-save-button">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
